import type { IconSvgObject } from './types';

const PathfinderOutlineIcon: IconSvgObject = [
  ["path", { d: "M15 6.5V4C15 2.89543 14.1046 2 13 2H4C2.89543 2 2 2.89543 2 4V13C2 14.1046 2.89543 15 4 15H6.5M9 17.5V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9H17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 13V11C9 9.89543 9.89543 9 11 9H13M11 15H13C14.1046 15 15 14.1046 15 13V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PathfinderOutlineIcon;
